import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc791e00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }

import { computed, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MoveablePanel',
  props: {
    width: {},
    height: {},
    left: { default: 10 },
    top: { default: 10 },
    title: { default: '' },
    moveable: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const x = ref(0)
const y = ref(0)
const moveablePanelRef = ref<HTMLElement>()
const realHeight = computed(() => {
  if (!props.height) {
    return moveablePanelRef.value?.clientHeight || 0
  }
  return props.height
})

onMounted(() => {
  if (props.left >= 0) x.value = props.left
  else x.value = document.body.clientWidth + props.left - props.width

  if (props.top >= 0) y.value = props.top
  else y.value = document.body.clientHeight + props.top - realHeight.value
})

const startMove = (e: MouseEvent) => {
  if (!props.moveable) return

  let isMouseDown = true

  const windowWidth = document.body.clientWidth
  const clientHeight = document.body.clientHeight

  const startPageX = e.pageX
  const startPageY = e.pageY

  const originLeft = x.value
  const originTop = y.value

  document.onmousemove = e => {
    if (!isMouseDown) return

    const moveX = e.pageX - startPageX
    const moveY = e.pageY - startPageY

    let left = originLeft + moveX
    let top = originTop + moveY

    if (left < 0) left = 0
    if (top < 0) top = 0
    if (left + props.width > windowWidth) left = windowWidth - props.width
    if (top + realHeight.value > clientHeight) top = clientHeight - realHeight.value

    x.value = left
    y.value = top
  }
  document.onmouseup = () => {
    isMouseDown = false

    document.onmousemove = null
    document.onmouseup = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", {
    class: "moveable-panel",
    ref_key: "moveablePanelRef",
    ref: moveablePanelRef,
    style: _normalizeStyle({
      width: _ctx.width + 'px',
      height: _ctx.height ? _ctx.height + 'px' : 'auto',
      left: x.value + 'px',
      top: y.value + 'px',
    })
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "header",
            onMousedown: _cache[1] || (_cache[1] = $event => startMove($event))
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", {
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, [
              _createVNode(_component_IconClose)
            ])
          ], 32),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "content",
          onMousedown: _cache[2] || (_cache[2] = $event => startMove($event))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 32))
  ], 4))
}
}

})